/* Dusky Rose - PDP size row composer.
 * Target layout (user spec): `Size: XS   [tape icon] Size guide` on ONE line.
 * Dawn's PILL picker legend renders just "Size" (the selected-value legend
 * exists only in the swatch branch), so this: (1) appends a live selected-
 * value readout to the legend, (2) moves the size-guide modal opener (a
 * separate block below) into the same legend row. Moving the DOM node
 * preserves the modal-opener custom element and its listeners.
 */
(function () {
  'use strict';

  function compose() {
    var legends = document.querySelectorAll('fieldset.product-form__input legend.form__label');
    var sizeLegend = null;
    legends.forEach(function (l) {
      if (/^\s*size\b/i.test(l.textContent)) sizeLegend = l;
    });
    if (!sizeLegend) return;
    var fieldset = sizeLegend.closest('fieldset');

    // live "Size: XS" readout
    if (!sizeLegend.querySelector('.dr-size-selected')) {
      var sel = document.createElement('span');
      sel.className = 'dr-size-selected';
      sizeLegend.appendChild(sel);
      var update = function () {
        var checked = fieldset ? fieldset.querySelector('input:checked') : null;
        sel.textContent = checked ? ': ' + checked.value : '';
      };
      update();
      if (fieldset) fieldset.addEventListener('change', update);
    }

    // pull the size-guide opener onto the same line
    var opener = document.querySelector('modal-opener.product-popup-modal__opener');
    if (opener && !sizeLegend.contains(opener)) {
      sizeLegend.classList.add('dr-size-legend');
      opener.classList.add('dr-size-guide-inline');
      sizeLegend.appendChild(opener);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', compose);
  } else {
    compose();
  }
  document.addEventListener('shopify:section:load', compose);
})();
